module.exports = {
   sanity: {
      projectId: process.env.GATSBY_SANITY_PROJECT_ID || "hn22l5cs",
      dataset: process.env.GATSBY_SANITY_DATASET || "production",
   },
};
